/**
 * Colors are also defined in the _colors.scss file.
 * Keep these files in sync.
 * This file is needed for cases when we need to provide color on the component input and we do not have access to scss variables from js.
 */
export default {
  // Grayscale
  mainBg: '#EDF0F2', // OLD one '#f2f5f6',
  blackPrimary: '#141c20',
  blackLight: '#54626C',
  blackUltralight: '#7C8B91',
  greyPrimary: '#9EAFB5',
  greyLight: '#BAC8CE',
  greyUltralight: '#F8FAFB',
  greyBorder: '#CFD8DC',
  greyBorderSecondary: '#E6EBED',
  greyBorderThird: '#D6D6D6',
  greyBorderModal: '#E0E7E9',
  greyChatBubble: '#EDF0F2',
  grayHover: '#F4F6F7',
  white: '#ffffff',

  // Links
  linkHover: '#EDF0F2',
  linkActive: '#E5E9EB',

  // Colors
  bluePrimary: '#2680EB',
  blueLight: '#83B8ED',
  blueUltraLight: '#eef5fe',
  blueExtraLight: '#F1F7FF',
  blueHover: '#D3E6FB',
  redPrimary: '#FF5B61',
  redLight: '#F5BFC1',
  redUltraLight: '#FFEBEC',
  greenPrimary: '#00BFA5',

  // Gradient colors
  avatar1: '#bbc4c7',
  avatar2: '#8b9a9f',

  // toast close button color
  toastCloseColor: '#b6c0c5',
  toastCircleHover: '#3c4b54',

  // Selection colors
  hover: '#F7F9FB',
  active: '#F4F5F8',
};
